export const MINIGAME_CONFIG = "MINIGAME_CONFIG";
export const MINIGAME_GET_SPIN_AWARD = "MINIGAME_GET_SPIN_AWARD";
export const MINIGAME_GET_SPIN_USER = "MINIGAME_GET_SPIN_USER";
export const MINIGAME_AWARD_LIST = "MINIGAME_AWARD_LIST";
export const MINIGAME_PIECE_COLLECTED = "MINIGAME_PIECE_COLLECTED";
export const MINIGAME_MISSIONS = "MINIGAME_MISSIONS";
export const MINIGAME_CHANGE_ATTEMP_BY_ID = "MINIGAME_CHANGE_ATTEMP_BY_ID";
export const MINIGAME_PRIZE_COLLECTION = "MINIGAME_PRIZE_COLLECTION";
export const MINIGAME_TAKE_PRIZE = "MINIGAME_TAKE_PRIZE";
export const MINIGAME_CURRENT_CYCLE_LIST_WINNER = "MINIGAME_CURRENT_CYCLE_LIST_WINNER";
export const MINIGAME_PAST_CYCLE_LIST_WINNER = "MINIGAME_PAST_CYCLE_LIST_WINNER";
export const MINIGAME_HISTORY = "MINIGAME_HISTORY";
export const MINIGAME_SPIN_HISTORY = "MINIGAME_SPIN_HISTORY";
export const MINIGAME_ADD_PIECE_LINK = "MINIGAME_ADD_PIECE_LINK";
export const MINIGAME_CONFIRM_PIECE_LINK = "MINIGAME_CONFIRM_PIECE_LINK";
export const MINIGAME_RANKING = "MINIGAME_RANKING";
export const MINIGAME_GET_RULE = "MINIGAME_GET_RULE";
export const MINI_SET_SPIN = "MINI_SET_SPIN";
export const MINIGAME_OPEN_POPUP_ERROR = "MINIGAME_OPEN_POPUP_ERROR"
export const SHOW_POPUP_LOGIN_MINI = "SHOW_POPUP_LOGIN_MINI";
export const SHOW_POPUP_EARNMORE = "SHOW_POPUP_EARNMORE";
export const SHOW_POPUP_PIECE = "SHOW_POPUP_PIECE";
export const SHOW_POPUP_CHANGE_COINS_SUCCESS = "SHOW_POPUP_CHANGE_COINS_SUCCESS";
export const SHOW_POPUP_GIVE_PIECE = "SHOW_POPUP_GIVE_PIECE";
export const SHOW_POPUP_GIVE_PIECE_SUCCESS = "SHOW_POPUP_GIVE_PIECE_SUCCESS";
export const SHOW_POPUP_MISSION = "SHOW_POPUP_MISSION";
export const SHOW_POPUP_PUZZLE = "SHOW_POPUP_PUZZLE";
export const SHOW_POPUP_INTRO_GIFT = "SHOW_POPUP_INTRO_GIFT";